import { DoctorInfoDtoIn } from '../../generated';
import { fromPersonToGenerated } from './person.parser';
import { Doctor } from '../../model/Doctor';
import { fromPhoneToGenerated } from './phoneNumber.parser';

export const fromDoctorToGenerated = (data: Doctor): DoctorInfoDtoIn => {
  return {
    ...fromPersonToGenerated(data),
    phoneNumber: data.phone.length > 0 ? fromPhoneToGenerated(data.phone) : undefined,
  }
}
